export const APP_HOST = "https://psb.baladz.net";
export const BE_HOST = "https://psb.baladz.net";
export const FOTO_HOST = "https://admin.baladz.net/assets/";
export const API_HOST = BE_HOST + "/api";
export const STORAGE_KEY = {
    AUTH_DATA: "AUTH",
    AUTH_ADM: "ADMToken",
    CONFIG_DATA: "ConfigData",
    EXPIRY_DATA: "ConfigExpiration"
}
export const HTTP_CODE = {
    ERR_NOT_AUTH: 401,
    ERR_FORBIDDEN: 403,
}
export const JENJANG_TUJUAN = {
    PAUDLQ: 'PAUDLQ',
    PAUDQ: 'PAUDQ',
    TKQ: 'TKQ',
    SD: 'SD'
};
export const KELAS_TUJUAN = {
    PAUDLQ: ["PAUDLQ"],
    PAUDQ: ["PAUDQ"],
    TKQ: ["TK A", "TK B"],
    SD: ["1", "2", "3", "4", "5", "6"]
}
export const KETERSEDIAAN = {
    SUDAH: "Sudah",
    BELUM: "Belum"
}
export const JENIS_BAYAR = {
    PENDAFTARAN: "Pendaftaran",
    DAFTAR_ULANG: "Daftar Ulang"
}
export const JENIS_KELAMIN = {
    LAKILAKI: 'Laki-Laki',
    PEREMPUAN: 'Perempuan'
}
export const PENANGGUNG_JAWAB_BIAYA = {
    ORANG_TUA: 'Orang Tua',
    DONATUR: 'Donatur'
}
export const CONTACT_WA = {
    AYAH: 'Ayah',
    IBU: 'Ibu',
    WALI: 'Wali'
}
export const JENJANG_PENDIDIKAN = {
    SD: 'SD',
    SMP: 'SMP',
    SMA: 'SMA',
    D1: 'D1',
    D2: 'D2',
    D3: 'D3',
    S1: 'S1',
    S2: 'S2',
    S3: 'S3',
    TIDAK_SEKOLAH: 'Tidak Sekolah'
}

export const METODE_PEMBAYARAN = {
    CASH: 'Cash',
    TRANSFER: 'Transfer',
    QRIS: 'Qris'
}

export const GOLONGAN_DARAH = {
    A: 'A',
    B: 'B',
    AB: 'AB',
    O: 'O',
    BELUM_ADA: 'Belum Ada'
}

export const TYPE_SEKOLAH_ASAL = {
    SD_NEGRI: 'SD Negeri',
    SDIT: 'SDIT',
    SD_SWASTA: 'SD Swasta',
    MI_NEGRI: 'MI Negeri',
    MI_SWASTA: 'MI Swasta',
    PKBM: 'PKBM',
    LAINYA: 'Lainya'
}

export const JENIS_BERKAS = {
    foto_santri: "Foto Calon Santri",
    surat_kesanggupan: "Surat Kesanggupan",
    akta_kelahiran: "Akta Kelahiran",
    kartu_keluarga: "Kartu Keluarga",
    bukti_hafalan: "Sertifikat Bukti Hafalan",
    bukti_biaya_pendaftaran: "Bukti Biaya Pendaftaran",
    bukti_biaya_daftar_ulang: "Bukti Biaya Daftar Ulang",
}

export const VERIFIED_BERKAS_FIELD = {
    foto_santri: "isFoto",
    surat_kesanggupan: "isSuratKesanggupan",
    akta_kelahiran: "isAktaKelahiran",
    kartu_keluarga: "isKartuKeluarga",
    bukti_hafalan: "isBuktiHafalan"

}

export const FORM_TYPE = {
    TEXT: "Text",
    DATEPICKER: "Datepicker"
}

export const FILTER_TYPE = {
    BAYAR_SUDAH: {
        title: 'Filter Bayar yang sudah',
        color: 'success',
        data: [
            { name: 'isBayarPendaftaran', value: 'Bayar Pendaftaran' },
            { name: 'isBayarDaftarUlang', value: 'Bayar Daftar Ulang' },
        ]
    },
    BAYAR_BELUM: {
        title: 'Filter Bayar yang belum',
        color: 'error',
        data: [
            { name: 'isBayarPendaftaran', value: 'Bayar Pendaftaran' },
            { name: 'isBayarDaftarUlang', value: 'Bayar Daftar Ulang' },
        ]
    },
    PROGRESS_SUDAH: {
        title: 'Filter Progress yang sudah',
        color: 'success',
        data: [
            { name: 'isIsi_formulir', value: 'Isi Formulir' },
            { name: 'isBayar_pendaftaran', value: 'Bayar Pendaftaran' },
            { name: 'isUpload_berkas', value: 'Upload Berkas' },
            { name: 'isBerkas_verified', value: 'Berkas Terverifikasi' },
            { name: 'isUndangan_ujian', value: 'Undangan Ujian' },
            { name: 'isUjian_seleksi', value: 'Ujian Seleksi' },
            { name: 'isLulus', value: 'Lulus Ujian' },
            { name: 'isHasil_pengumuman', value: 'Hasil Pengumuman' },
            { name: 'isBayar_daftar_ulang', value: 'Bayar Daftar Ulang' }
        ]
    },
    PROGRESS_BELUM: {
        title: 'Filter Progress yang belum',
        color: 'error',
        data: [
            { name: 'isIsi_formulir', value: 'Isi Formulir' },
            { name: 'isBayar_pendaftaran', value: 'Bayar Pendaftaran' },
            { name: 'isUpload_berkas', value: 'Upload Berkas' },
            { name: 'isBerkas_verified', value: 'Berkas Terverifikasi' },
            { name: 'isUndangan_ujian', value: 'Undangan Ujian' },
            { name: 'isUjian_seleksi', value: 'Ujian Seleksi' },
            { name: 'isLulus', value: 'Lulus Ujian' },
            { name: 'isHasil_pengumuman', value: 'Hasil Pengumuman' },
            { name: 'isBayar_daftar_ulang', value: 'Bayar Daftar Ulang' }
        ]
    },
    BERKAS_SUDAH: {
        title: 'Filter Berkas yang sudah',
        color: 'success',
        data: [
            { name: 'isFoto', value: 'Foto' },
            { name: 'isSuratKesanggupan', value: 'Surat Kesanggupan' },
            { name: 'isAktaKelahiran', value: 'Akta Kelahiran' },
            { name: 'isKartuKeluarga', value: 'Kartu Keluarga' },
            { name: 'isBuktiHafalan', value: 'Bukti Hafalan' }
        ]
    },
    BERKAS_BELUM: {
        title: 'Filter Berkas yang belum',
        color: 'error',
        data: [
            { name: 'isFoto', value: 'Foto' },
            { name: 'isSuratKesanggupan', value: 'Surat Kesanggupan' },
            { name: 'isAktaKelahiran', value: 'Akta Kelahiran' },
            { name: 'isKartuKeluarga', value: 'Kartu Keluarga' },
            { name: 'isBuktiHafalan', value: 'Bukti Hafalan' }
        ]
    }

}
export const CONFIG_PENDAFTARAN = {
    TAHUN_AJARAN: 'tahunAjaran',
    TGL_UPLOAD_BERKAS_TERAKHIR: 'lastUploadBerkas',
    UANG_PENDAFTARAN: 'uangDaftar',
    TGL_UANG_DAFTAR_TERAKHIR: 'lastUangDaftar',
    TGL_UANG_DAFTAR_ULANG_TERAKHIR: 'lastUangDaftarUlang',
    TGL_TEST: 'jadwalTest',
    TEMPAT_TEST: 'tempatTest',
    WAKTU_TEST: 'waktuTest',
    TGL_PENGUMUMAN_TEST: 'pengumumanDate',
    WA_CONTACT_US: 'wa_contact',
    NOMOR_WA: 'noWA',
    INFO_PEMBAYARAN: 'infoBayar',
    UANG_DAFTAR_ULANG: 'uangDaftarUlang'
}

export const STATUS_PROGRESS = {
    ISI_FORMULIR: 'Isi Formulir',
    BERKAS_VERIFIED: 'Berkas Terverifikasi',
    UNDANGAN_UJIAN: 'Undangan Ujian',
    UJIAN: 'Ujian',
    PENGUMUMAN: 'Pengumuman',
    BAYAR_DAFTAR_ULANG: 'Bayar Daftar Ulang'
}